import HCPWidget from './hcp-widget';
import { runOnAmplitudeReady, variantForExperiment, runOnDocumentReady, isMobileDevice } from '@/js/helpers';
import { HCPInactivityDetector } from '@/js/utils/hcp-inactivity-detector';
import { HCPViewportDetector } from '@/js/utils/hcp-viewport-detector';
const DEFAULT_TIMEOUT = 3000;
const WALNUT_ELEMENT_IDS = ['#walnut-product-tour', '.walnut-container', '#block-walnut-iframe'];
const EXPERIMENT_KEY = 'q4y25_cro_product-tour_v1';
const TEST_VARIANT = 'test_q4y25_cro_product-tour_v1';
const hcpProductTourWidget = new HCPWidget();
const getIsElectricalCampaign = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('utm_campaign')?.includes('electric');
};
const getIsPageElectrical = () => {
    return window.location.pathname.includes('/industries/electrical-contractor-software/');
};
runOnDocumentReady(() => {
    const isElectricalCampaign = getIsElectricalCampaign();
    const isPageElectrical = getIsPageElectrical();
    if ((!isElectricalCampaign && !isPageElectrical) || isMobileDevice()) {
        return;
    }
    runOnAmplitudeReady(() => {
        variantForExperiment(EXPERIMENT_KEY)
            .then((variant) => {
            if (variant !== TEST_VARIANT) {
                return;
            }
            const selectorString = WALNUT_ELEMENT_IDS.join(',');
            const elements = document.querySelectorAll(selectorString);
            // Check when walnut iframe is visible and hide the widget or show it when it's out of view
            const viewportDetector = new HCPViewportDetector(elements, {
                onEnter: () => {
                    hcpProductTourWidget.hideWidget();
                },
                onLeave: () => {
                    hcpProductTourWidget.showWidget();
                },
            });
            // Check when user is inactive and show the widget expanded
            new HCPInactivityDetector({
                onInactive: () => {
                    if (viewportDetector.isVisible() ||
                        hcpProductTourWidget.isExpanded() ||
                        hcpProductTourWidget.pressedCloseButtonOnce) {
                        return;
                    }
                    hcpProductTourWidget.showWidget();
                    hcpProductTourWidget.expandWidget();
                },
                timeoutDelay: DEFAULT_TIMEOUT,
            });
            // Show the widget after a timeout
            setTimeout(() => {
                if (viewportDetector.isVisible()) {
                    return;
                }
                hcpProductTourWidget.showWidget();
            }, DEFAULT_TIMEOUT);
        })
            .catch(() => { });
    });
});
